module Router

open Elmish.UrlParser
open Elmish.Navigation
open Shared

type Route =
    | Home
    | Pixie
    | Bargarn
    | Touchpoint
    | Shelfinity
    | SBH
    | Effecta
    | Bidflowcom
    | Endurance
    | Direktpress

let idx state = custom "idx" (id >> Ok) state

let routeParser : Parser<Route->Route, Route> =
    oneOf
        [
          map Route.Home top
          map Route.Home (s "home")
          map Route.Pixie (s "pixie")
          map Route.Bargarn (s "bargarn")
          map Route.Touchpoint (s "touchpoint")
          map Route.Shelfinity (s "shelfinity")
          map Route.SBH (s "sbh")
          map Route.Effecta (s "effecta")
          map Route.Bidflowcom (s "bidflowcom")
          map Route.Endurance (s "endurance")
          map Route.Direktpress (s "direktpress")
        ]

let toPath =
    function
    | Route.Home -> "/"
    | Route.Pixie -> "/pixie"
    | Route.Bargarn -> "/bargarn"
    | Route.Touchpoint -> "/touchpoint"
    | Route.Shelfinity -> "/shelfinity"
    | Route.SBH -> "/sbh"
    | Route.Effecta -> "/effecta"
    | Route.Bidflowcom -> "/bidflowcom"
    | Route.Endurance -> "/endurance"
    | Route.Direktpress -> "/direktpress"

let navigateTo page = page |> toPath |> Navigation.newUrl

let modifyUrl page = page |> toPath |> Navigation.modifyUrl

let getRouteFromProjectId (id: int) =
    match id with
    | 1 -> Route.Bidflowcom
    | 2 -> Route.Effecta
    | 3 -> Route.SBH
    | 4 -> Route.Endurance
    | 5 -> Route.Direktpress
    | 6 -> Route.Pixie
    | 7 -> Route.Bargarn
    | 8 -> Route.Touchpoint
    | 9 -> Route.Shelfinity
    | _ -> Route.Home
